var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"stripe_form",attrs:{"action":_vm.processRoute,"method":"POST"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }